"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import "../styles/FinanceiroDono.css"

const API = "https://api.ticketdovaqueiro.com/api"

const FinanceiroDono = () => {
  const [totalVendasLiquidas, setTotalVendasLiquidas] = useState(0)
  const [totalEntradas, setTotalEntradas] = useState(0)
  const [totalGeralLiquido, setTotalGeralLiquido] = useState(0)
  const [totalSaquesAprovados, setTotalSaquesAprovados] = useState(0)
  const [totalSaquesPendentes, setTotalSaquesPendentes] = useState(0)
  const [disponivelFinal, setDisponivelFinal] = useState(0)
  const [loading, setLoading] = useState(true)
  const [extratosSaques, setExtratosSaques] = useState([])
  const [entradas, setEntradas] = useState([])

  // Estado para Modal Saque
  const [showModal, setShowModal] = useState(false)
  const [valorSaque, setValorSaque] = useState("")
  const [tipoPix, setTipoPix] = useState("cpf")
  const [chavePix, setChavePix] = useState("")
  const [mensagem, setMensagem] = useState("")

  useEffect(() => {
    const fetchFinanceiro = async () => {
      try {
        const token = localStorage.getItem("token")
        const headers = { Authorization: `Bearer ${token}` }

        // O backend já separa as origens: presencial entra 100%, antecipada sofre taxa,
        // e aporte/patrocínio entra 100% sem taxa.
        const resTotal = await axios.get(`${API}/dono/financeiro/total-com-taxa`, { headers })
        const vendasLiquidas = Number.parseFloat(resTotal.data.totalVendasLiquidas || 0)
        const entradasAtivas = Number.parseFloat(resTotal.data.totalEntradas || 0)
        const totalFinanceiroBackend = Number.parseFloat(resTotal.data.totalGeralLiquido || 0)

        let listaEntradas = []
        try {
          const resEntradas = await axios.get(`${API}/finance/minhas-entradas`, { headers })
          listaEntradas = Array.isArray(resEntradas.data.entradas) ? resEntradas.data.entradas : []
        } catch (errEntradas) {
          console.error("Erro ao carregar entradas externas:", errEntradas)
        }

        const resSaques = await axios.get(`${API}/dono/financeiro/meus-saques`, { headers })
        const listaSaques = Array.isArray(resSaques.data) ? resSaques.data : []
        setExtratosSaques(listaSaques)

        const saquesAprovados = listaSaques.filter((s) => s.status === "aprovado")
        const totalSaques = saquesAprovados.reduce((acc, saque) => acc + Number(saque.valor || 0), 0)
        const saquesPendentes = listaSaques.filter((s) => s.status === "pendente")
        const totalSaques2 = saquesPendentes.reduce((acc, saque) => acc + Number(saque.valor || 0), 0)

        const totalComEntradas = totalFinanceiroBackend
        const disponivel = totalComEntradas - totalSaques

        setTotalVendasLiquidas(vendasLiquidas)
        setTotalEntradas(entradasAtivas)
        setEntradas(listaEntradas)
        setTotalGeralLiquido(totalComEntradas)
        setTotalSaquesAprovados(totalSaques)
        setTotalSaquesPendentes(totalSaques2)
        setDisponivelFinal(disponivel)
      } catch (err) {
        console.error("Erro ao carregar dados financeiros:", err)
      } finally {
        setLoading(false)
      }
    }

    fetchFinanceiro()
  }, [])

  const handleSolicitarSaque = async () => {
    try {
      const token = localStorage.getItem("token")

      if (!valorSaque || !chavePix) {
        setMensagem("Preencha todos os campos.")
        return
      }

      if (Number.parseFloat(valorSaque) > disponivelFinal) {
        setMensagem(`O valor solicitado não pode ser maior que R$ ${disponivelFinal.toFixed(2)}`)
        return
      }

      const res = await axios.post(
        `${API}/dono/financeiro/solicitar-saque`,
        {
          valor: Number.parseFloat(valorSaque),
          chavePix: {
            tipo: tipoPix,
            valor: chavePix,
          },
        },
        { headers: { Authorization: `Bearer ${token}` } },
      )

      setMensagem(res.data.mensagem)
      setShowModal(false)
      setValorSaque("")
      setChavePix("")
      window.location.reload()
    } catch (err) {
      console.error("Erro ao solicitar saque:", err.response ? err.response.data : err)
      setMensagem(err.response?.data?.mensagem || "Erro ao solicitar saque.")
    }
  }

  const formatarMoeda = (valor) =>
    Number(valor || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })

  const formatarTipoEntrada = (tipo) => (tipo === "patrocinio" ? "Patrocínio" : "Aporte")

  if (loading) {
    return <div className="loading-container">🔄 Carregando informações financeiras...</div>
  }

  return (
    <div className="financeiro-containerdono">
      <h2>💰 Resumo Financeiro</h2>

      <div className="grid-financeirodono">
        <div className="grid-itemdono destaque">
          <h4>Total Disponível para Saque:</h4>
          <p>
            <strong>{formatarMoeda(disponivelFinal)}</strong>
          </p>
        </div>

        <div className="grid-itemdono">
          <h4>Vendas Líquidas:</h4>
          <p>{formatarMoeda(totalVendasLiquidas)}</p>
          <small>Presenciais 100% + antecipadas após taxa do site</small>
        </div>

        <div className="grid-itemdono">
          <h4>Entradas Externas:</h4>
          <p>{formatarMoeda(totalEntradas)}</p>
          <small>Aportes e patrocínios sem taxa da plataforma</small>
        </div>

        <div className="grid-itemdono">
          <h4>Total Financeiro:</h4>
          <p>{formatarMoeda(totalGeralLiquido)}</p>
          <small>Vendas líquidas + entradas externas</small>
        </div>

        <div className="grid-itemdono">
          <h4>Saques Aprovados:</h4>
          <p>{formatarMoeda(totalSaquesAprovados)}</p>
        </div>

        <div className="grid-itemdono">
          <h4>Saques Pendentes:</h4>
          <p>{formatarMoeda(totalSaquesPendentes)}</p>
        </div>
      </div>

      <div className="descricao-extrato">
        <h3>➕ Entradas da Vaquejada</h3>
      </div>

      <div className="table-responsive">
        <table className="extrato-tabela">
          <thead>
            <tr>
              <th>Data</th>
              <th>Vaquejada</th>
              <th>Tipo</th>
              <th>Descrição</th>
              <th>Valor</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {entradas.length === 0 ? (
              <tr>
                <td colSpan="6">Nenhum aporte ou patrocínio lançado.</td>
              </tr>
            ) : (
              entradas.map((entrada) => (
                <tr key={entrada._id} style={entrada.status === "cancelado" ? { opacity: 0.55 } : undefined}>
                  <td>{new Date(entrada.dataEntrada || entrada.createdAt).toLocaleDateString("pt-BR")}</td>
                  <td>{entrada.evento?.nome || "—"}</td>
                  <td>{formatarTipoEntrada(entrada.tipo)}</td>
                  <td>{entrada.descricao || "—"}</td>
                  <td>{formatarMoeda(entrada.valor)}</td>
                  <td>
                    <span className={`status ${entrada.status === "ativo" ? "aprovado" : "cancelado"}`}>
                      {entrada.status === "ativo" ? "Ativa" : "Cancelada"}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="descricao-extrato">
        <h3>📄 Extratos de Saque</h3>
        <button className="botao-saque" onClick={() => setShowModal(true)}>
          Solicitar Saque
        </button>
      </div>

      <div className="table-responsive">
        <table className="extrato-tabela">
          <thead>
            <tr>
              <th>Data</th>
              <th>Valor</th>
              <th>Tipo Pix</th>
              <th>Chave Pix</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {extratosSaques.length === 0 ? (
              <tr>
                <td colSpan="5">Nenhum saque encontrado.</td>
              </tr>
            ) : (
              extratosSaques.map((saque, index) => (
                <tr key={saque._id || index}>
                  <td>
                    {saque.status === "pendente"
                      ? new Date(saque.dataSolicitacao || saque.dataCriacao).toLocaleString("pt-BR")
                      : saque.dataAtualizacao
                        ? new Date(saque.dataAtualizacao).toLocaleString("pt-BR")
                        : new Date(saque.dataSolicitacao || saque.dataCriacao).toLocaleString("pt-BR")}
                  </td>
                  <td>{formatarMoeda(saque.valor)}</td>
                  <td>{saque.chavePix?.tipo || "—"}</td>
                  <td>{saque.chavePix?.valor || "—"}</td>
                  <td>
                    <span className={`status ${saque.status}`}>
                      {saque.status === "aprovado" && "Transferido"}
                      {saque.status === "pendente" && "Pendente"}
                      {saque.status === "cancelado" && "Cancelado"}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Solicitar Saque</h3>

            <label>Valor do Saque:</label>
            <input type="number" min="0" step="0.01" value={valorSaque} onChange={(e) => setValorSaque(e.target.value)} />

            <label>Tipo de Chave Pix:</label>
            <select value={tipoPix} onChange={(e) => setTipoPix(e.target.value)}>
              <option value="cpf">CPF</option>
              <option value="email">Email</option>
              <option value="telefone">Telefone</option>
              <option value="aleatoria">Aleatória</option>
            </select>

            <label>Chave Pix:</label>
            <input type="text" value={chavePix} onChange={(e) => setChavePix(e.target.value)} />

            <div className="modal-buttons">
              <button onClick={handleSolicitarSaque}>Confirmar Saque</button>
              <button onClick={() => setShowModal(false)}>Cancelar</button>
            </div>

            {mensagem && <p>{mensagem}</p>}
          </div>
        </div>
      )}
    </div>
  )
}

export default FinanceiroDono
